import styled from '@emotion/styled';
import { Button, colors, Stack, Typography } from '@ui-components/neo.tax';
import { ReactComponent as AutomationsIcon } from '@ui-components/neo.tax/dist/icons/automations.svg';

export const StyledAutomationsIcon = styled(AutomationsIcon)({
  height: 24,
  width: 24,
  color: colors.blue[600],
});

export const StyledSyncingStack = styled(Stack)({
  gap: 8,
});

export const StyledSyncingText = styled(Typography)({
  color: colors.gray[500],
  textAlign: 'center',
});

export const StyledConnectProvider = styled.div({
  width: 512,
});

// ConnectProviderActions
export const StyledSingleActionButton = styled(Button)({
  display: 'inline-block',
  textAlign: 'center',
  width: '100%',
  marginTop: 20,
});

export const StyledDoubleActionButton = styled(Button)({
  display: 'inline-block',
  textAlign: 'center',
  minWidth: 226,
  width: '100%',
});

export const StyledActionText = styled(Typography)({
  color: colors.gray[400],
  paddingTop: 12,
});
